import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

interface Health {
  status: 'ok' | 'degraded' | 'down';
  litellm: boolean;
  timestamp: string;
}

export function HealthBadge() {
  const { data } = useQuery({
    queryKey: ['health'],
    queryFn: () => api<Health>('/api/health'),
    refetchInterval: 60_000,
  });

  const status = data?.status ?? 'unknown';
  const dotColor =
    status === 'ok' ? '#22c55e' : status === 'degraded' ? '#eab308' : '#ef4444';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 13,
        color: '#475569',
      }}
      title={`LiteLLM: ${data?.litellm ? 'reachable' : 'unreachable'}`}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: dotColor,
          display: 'inline-block',
        }}
      />
      <span style={{ textTransform: 'capitalize' }}>{status}</span>
    </div>
  );
}
